/* eslint-disable no-return-assign */
<template>
  <div class="step_container">
     <a-form-model
        layout="horizontal"
        :model="threeForm"
        :rules="rules"
        ref="person_third_form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
    <h1 class="step_title">AUTHORIZED PERSON 授权人</h1>
    <div class="step_question_container">
      <h2 class="step_question_title">AUTHORIZED PERSON 授权人 1</h2>
        <a-form-model-item
          required
          prop="has_authorize_other"
          label="Do you authorize others to process your foreign exchange? 您是否授权他人处理您的外汇？"
        >
          <a-radio-group
            :disabled='disabled'
            class="modify_antd_radio_id"
            name="has_authorize_other"
            v-model="threeForm.has_authorize_other"
          >
            <a-radio :value="true"> Yes 是 </a-radio>
            <a-radio :value="false"> No 否 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div v-if="has_authorize_other">
          <div class="mutiple_form_layout">
            <a-form-model-item
              prop="authorize1_title"
              :style="GetScreenStyle.width30percent"
              required
              label="Title 称谓"
            >
              <a-select
                :disabled='disabled'
                v-model="threeForm.authorize1_title"
              >
                <a-select-option value="Mr"> Mr </a-select-option>
                <a-select-option value="Miss"> Miss </a-select-option>
                <a-select-option value="Ms"> Ms </a-select-option>
                <a-select-option value="Other"> Other </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              prop="authorize1_first_name"
              required
              label="First Name 名"
            >
              <a-input
                :disabled='disabled'
                v-model="threeForm.authorize1_first_name"
                @change="(e)=>{
                handleInput(e, 'authorize1_first_name')
              }"
              />
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              prop="authorize1_last_name"
              required
              label="Last Name 姓"
            >
              <a-input
                :disabled='disabled'
                v-model="threeForm.authorize1_last_name"
                @change="(e)=>{
                handleInput(e, 'authorize1_last_name')
              }"
              />
            </a-form-model-item>
          </div>
          <a-form-model-item
            :style="GetScreenStyle.width45percent"
            required
            prop="authorize1_gender"
            label="Gender 性别"
          >
            <a-radio-group
              class="modify_antd_radio_id"
              :disabled='disabled'
              v-model="threeForm.authorize1_gender"
              name="authorize1_gender"
            >
              <a-radio value="male"> Male </a-radio>
              <a-radio value="female"> Female </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div class="mutiple_form_layout">
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="authorize1_date_of_birth"
              label="出生日期"
            >
            <a-date-picker
              :inputReadOnly='true'
              :disabled='disabled'
              style="width:100%"
              @change="(e)=>{
                handleDatePick(e, 'authorize1_date_of_birth')
              }"
              :value="authorize1_dob_formate"
              placeholder="Date of Birth 出生日期"
              >
            </a-date-picker>
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="authorize1_place_of_birth"
              label="Place of Birth 出生地点"
            >
              <a-input
                v-model="threeForm.authorize1_place_of_birth"
                :disabled='disabled'
                @change="(e)=>{
                handleInput(e, 'authorize1_place_of_birth')
              }"
              />
            </a-form-model-item>
            <BaseCountrySelection
              :style="GetScreenStyle.width30percent"
              label="Nationality 国籍及地区"
              prop="authorize1_nationality"
              :disabled="disabled"
              :selectedVal='threeForm.authorize1_nationality'
              @handleChange='handleSelect'
              valType='code'
            >
            </BaseCountrySelection>
          </div>
          <div class="mutiple_form_layout">
            <BaseCountrySelection
              :style="GetScreenStyle.width45percent"
              label="Country of Tax Residence 税务国家"
              prop="authorize1_tax_country"
              :disabled="disabled"
              :selectedVal='threeForm.authorize1_tax_country'
              @handleChange='handleSelect'
              valType='code'
            >
            </BaseCountrySelection>
            <a-form-model-item
              :style="GetScreenStyle.width45percent"
              label="Relationship 与授权人关系"
              prop="authorize1_relation"
            >
              <a-input
                :disabled='disabled'
                v-model="threeForm.authorize1_relation"
                @change="(e)=>{
                handleInput(e, 'authorize1_relation')
              }"
              />
            </a-form-model-item>
          </div>
          <div class="mutiple_form_layout">
          <a-form-model-item
          :style="GetScreenStyle.width60percent"
          prop="authorize1_residential_address"
          label="Residential Address(No Po BOX) 居住地址">
          <BaseAddress
              prop="authorize1_residential_address"
              :disabled="disabled"
              :value="threeForm.authorize1_residential_address"
              @handleChange='handleSelect'
            />
            <!-- <a-input
              :disabled='disabled'
              v-model="threeForm.authorize1_residential_address"
              @change="(e)=>{
                handleInput(e, 'authorize1_residential_address')
              }"
            /> -->
          </a-form-model-item>
          <BaseCountrySelection
            :style="GetScreenStyle.width30percent"
            label="Country 国家(及地区)"
            prop="authorize1_country"
            :disabled="disabled"
            :selectedVal='threeForm.authorize1_country'
            @handleChange='handleSelect'
            valType='code'
          >
          </BaseCountrySelection>
          </div>
          <div class="mutiple_form_layout">
            <a-form-model-item
              prop="authorize1_city"
              :style="GetScreenStyle.width30percent"
              required
              label="City 城市"
            >
              <a-input
                v-model="threeForm.authorize1_city"
                :disabled='disabled'
                @change="(e)=>{
                handleInput(e, 'authorize1_city')
              }"
              />
            </a-form-model-item>
          <a-form-model-item
              prop="authorize1_suburb"
              :style="GetScreenStyle.width30percent"
              required
              label="Suburb 地区"
            >
              <a-input
                v-model="threeForm.authorize1_suburb"
                :disabled='disabled'
                @change="(e)=>{
                handleInput(e, 'authorize1_suburb')
              }"
              />
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="authorize1_postcode"
              label="Postcode 邮政编码"
            >
              <a-input
                v-model="threeForm.authorize1_postcode"
                :disabled='disabled'
                @change="(e)=>{
                handleInput(e, 'authorize1_postcode')
              }"
              />
            </a-form-model-item>
          </div>
          <div class="mutiple_form_layout">
            <BaseCountrySelection
              :style="GetScreenStyle.width30percent"
              label="Area Code 区号"
              prop="authorize1_dial_code"
              :disabled="disabled"
              :selectedVal='threeForm.authorize1_dial_code'
              @handleChange='handleSelect'
              valType='dial_code'
            >
            </BaseCountrySelection>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="authorize1_mobile_phone"
              label="Mobile 移动电话"
            >
              <a-input
                :disabled='disabled'
                v-model="threeForm.authorize1_mobile_phone"
                @change="(e)=>{
                handleInput(e, 'authorize1_mobile_phone')
              }"
              />
            </a-form-model-item>
            <a-form-model-item
              prop="authorize1_email_address"
              :style="GetScreenStyle.width30percent"
              required
              label="E-mail 电子邮箱"
            >
              <a-input
                :disabled='disabled'
                v-model="threeForm.authorize1_email_address"
                @change="(e)=>{
                handleInput(e, 'authorize1_email_address')
              }"
              />
            </a-form-model-item>
          </div>
          <div class="mutiple_form_layout">
          <a-form-model-item
            :style="GetScreenStyle.width45percent"
            label="Identification type(证件类型)"
            prop="authorize1_identification_type"
            required
          >
            <a-select
              :disabled='disabled'
              v-model="threeForm.authorize1_identification_type"
            >
              <a-select-option value="Passport"> Passport(Recommend) </a-select-option>
              <a-select-option value="birth_certificate"> Birth Certificate </a-select-option>
              <a-select-option value="business_certificate"> Business Certificate </a-select-option>
              <a-select-option value="chinese_id_card"> Chinese ID Card </a-select-option>
              <a-select-option value="citizenship_certificate"> Citizenship Certificate </a-select-option>
              <a-select-option value="eightteen_plus_card"> NZ 18+ Card </a-select-option>
              <a-select-option value="nz_firearm_license"> NZ Firearm License </a-select-option>
              <a-select-option value="nz_au_drivers_licence"> NZ/AU Drivers Licence </a-select-option>
              <a-select-option value="other"> Other </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            required
            :style="GetScreenStyle.width45percent"
            label="ID number 证件号码"
            prop="authorize1_id_num"
          >
            <a-input
              :disabled='disabled'
              v-model="threeForm.authorize1_id_num"
              @change="(e)=>{
                handleInput(e, 'authorize1_id_num')
              }"
            />
          </a-form-model-item>

        </div>
        <!-- 证件上传 -->
        <div class="mutiple_form_layout">
          <a-form-model-item
          :style="GetScreenStyle.width30percent"
            label="Issue Date 签发日期"
            required
            prop='authorize1_issue_date'
            >
            <a-date-picker
              :inputReadOnly='true'
              :disabled='disabled'
              style="width:100%"
              @change="(e)=>{
                handleDatePick(e, 'authorize1_issue_date')
              }"
              :value="authorize1_issue_date_formate"
              >
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item
          :style="GetScreenStyle.width30percent"
            label="Expiry Date失效日期"
            required
            prop='authorize1_expiry_date'
            >
            <a-date-picker
              :disabled='disabled'
              :inputReadOnly='true'
              style="width:100%"
              @change="(e)=>{
                handleDatePick(e, 'authorize1_expiry_date')
              }"
              :value="authorize1_expiry_date_formate"
              >
            </a-date-picker>
          </a-form-model-item>
          <BaseCountrySelection
            :style="GetScreenStyle.width30percent"
            label="Issue Country(签发国家)"
            prop="authorize1_issue_country"
            :disabled="disabled"
            :selectedVal='threeForm.authorize1_issue_country'
            @handleChange='handleSelect'
            valType='code'
          >
          </BaseCountrySelection>
        </div>
          <div>
            <!-- asdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasd -->
            <div>
          <div class="step_checkbox_layout">
            <div class="step_sub_title">
              Please upload your ID Vertification 请上传您的ID认证
            </div>
            <ul class="step_ul_style">
              <li>
                Face-to-face channel: with United AU staff assistance to verify
                your documents.
              </li>
              <li>
                Non face-to-channel: without United AU staff assistance to verify
                your documents.
              </li>
            </ul>
          </div>
          <a-form-model-item
            :style="GetScreenStyle.width100percent"
            required
            label="Choose the channel before uploading your proof of identification:"
            prop="authorize1_prove_channel"
          >
            <a-select
              :disabled='disabled'
              v-model="threeForm.authorize1_prove_channel"
            >
              <a-select-option value="face_to_face"
                >Face-to-face Channel</a-select-option
              >
              <a-select-option value="none_face_to_face"
                >None Face-to-face Channel
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- face_to_face 上传 -->
          <a-form-model-item
            v-if="threeForm.authorize1_prove_channel == 'face_to_face'"
            :style="GetScreenStyle.width100percent"
            required
            prop="authorize1_face_to_face_type"
            label="Please choose ONE of the following:"
          >
            <a-radio-group
              :disabled='disabled'
              class="modify_antd_radio"
              name="authorize1_face_to_face_type"
              v-model="threeForm.authorize1_face_to_face_type"
            >
              <a-radio :style="radioStyle" :value="1">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand Passport 澳大利亚/新西兰护照 (the copy
                    of passport photo and signature page 护照信息页和签字页)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese passport 中国护照 (the copy of passport photo,
                    signature page and visa page 护照信息页，签字页和签证页)
                  </li>
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="3">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese passport 中国护照 (the copy of passport photo, signature page and visa page 护照信息页，签字页和签证页);
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="4">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Other passport 其他护照 (the copy of passport photo,
                    signature page and visa page 护照信息页，签字页和签证页)
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <!-- none-face-to-face 证件上传 -->
          <a-form-model-item
            v-if="threeForm.authorize1_prove_channel == 'none_face_to_face'"
            :style="GetScreenStyle.width100percent"
            required
            prop="authorize1_none_face_to_face_type"
            label="Please choose ONE of the following:"
          >
            <a-radio-group
              class="modify_antd_radio"
              :disabled='disabled'
              name="authorize1_none_face_to_face_type"
              v-model="threeForm.authorize1_none_face_to_face_type"
            >
              <a-radio :style="radioStyle" :value="1">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand Passport 澳大利亚/新西兰护照 (the copy
                    of passport photo and signature page 护照信息页和签字页)
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 驾照正反面)
                  </li>
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                  <li>
                    Chinese Passport (the copy of passport photo, signature page
                    and visa page 护照信息页，签字页和签证页《如有》)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="3">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                  <li class="li_require">
                    Chinese bank card (the copy of front and back side
                    银行卡正面)
                  </li>
                  <li>
                    Chinese Passport (the copy of passport photo, signature page
                    and visa page 护照信息页，签字页和签证页《如有》)
                  </li>
                </ul>
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div v-if="authorize1_prove_channel">

            <AFileMessage
              v-for="item in author1IdProve[threeForm.authorize1_prove_channel][author1ProveIndex]"
              :key="item.id"
              :obj='item'
              @handleInput='handleInput'
              @handleFileChange="handleFileList"
              @FileValidate='FileValidate'
              :disabled='disabled'
              @handleSelect='handleSelect'
            />
          </div>
        </div>
            <!-- asdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasd -->
            <div>
              <div class="step_sub_title">
              Please upload your Proof of Address(select one)
              请上传您的地址认证（请选择一个上传）
            </div>
              <div class="ul_main_title">
                1.Bank Statements and Bank Correspondence 银行对账单和银行通信
              </div>
              <ul class="step_ul_style">
                <li>
                  This must be a statement from a bank/IRD that has been posted
                  to the client and is dated within the last 3 months.
                  这必须是银行/
                  IRD的记录，该记录信件必须是最近三个月内通过信件发送给注册人的。
                </li>
                <li>
                  Bank correspondence must confirm a business relationship
                  exists between the bank and the client.
                  银行通信必须是能确认银行与注册人之间存在业务关系的
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                </li>
              </ul>
            </div>
            <!-- 2. -->
            <div>
              <div class="ul_main_title">2.Utility Bill 各种账单</div>
              <ul class="step_ul_style">
                <li>
                  This must be a statement for utility service at a fixed
                  location that has been posted to the client and is dated
                  within the last 3 months.
                  这必须最近三个月内通过邮寄发送去注册人的账单。
                </li>
                <li>
                  Fixed services include electricity, water, gas, home
                  internet/landlines and Sky.
                  服务账单包括电力，水，煤气，家庭互联网/固定电话和电视。
                </li>
                <li>
                  Fixed services do not include mobile phones.
                  服务账单不包括手机账单
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. . 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                </li>
              </ul>
            </div>
            <!-- 3. -->
            <div>
              <div class="ul_main_title">
                3.Government Agency Correspondence (Council Rates, etc.)
                政府机构通信
              </div>
              <ul class="step_ul_style">
                <li>
                  This must be a statement, letter or invoice that has been
                  posted to the client from a government agency and is dated
                  within the last 3 months.
                  这必须最近三个月内来自政府机构通过邮寄发送去注册人的声明/信件/发票。
                </li>
                <li>
                  This includes confirmation of bond lodgements with the
                  Department of Building and Housing.
                  这可以是来自于建筑和住房部押金投管确认信
                </li>
                <li>
                  Fixed services do not include mobile phones.
                  服务账单不包括手机账单
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. . 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                </li>
              </ul>
            </div>
            <!-- 4. -->
            <div>
              <div class="ul_main_title">
                4.Electoral Commission Correspondence 选举委员会函件
              </div>
              <ul class="step_ul_style">
                <li>
                  This must be a letter that has been posted to the client and
                  is dated within the last 3 months.
                  这必须是三个月内通过邮寄发送至注册人的信件
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. . 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息
                </li>
              </ul>
            </div>
            <!-- 5. -->
            <div>
              <div class="ul_main_title">
                5.Tenancy Agreement 租赁协议 Correspondence 选举委员会函件
              </div>
              <ul class="step_ul_style">
                <li>
                  This must be a signed tenancy agreement dated within the last
                  3 months. 这必须是过去3个月内签署的租赁协议
                </li>
              </ul>
            </div>
            <!-- 6. -->
            <div>
              <div class="ul_main_title">6.Vehicle Registration 车辆登记</div>
              <ul class="step_ul_style">
                <li>
                  This must be a current vehicle registration that has been
                  posted to the client and is dated within the last 3 months.
                  这必须是三个月内通过邮寄发送给注册人的车辆登记信件
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. . 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                </li>
              </ul>
            </div>
            <!-- 地址认证上传 -->
            <div class="step_upload_box marginT_10">
              <AUploadFile
                title=""
                prop="authorize1_address_prove_file_list"
                :fileList="authorize1_address_prove_file_list || []"
                @handleFileChange="handleFileList"
                :disabled='disabled'
                @FileValidate="FileValidate"
                />
              <div class="step_notice_text marginT_10">
                The file's fomat supports JPG,PNG,JPEG,PDF or any video types
                and the size is not exceed 20MB
              </div>
            </div>
            <div>
              <div class="step_sub_title">
              Authorized Person Signature 授权人签名
              <a-form-model-item
              prop="authorize1_signature_key"
              >
              <Signature
              class="marginX20"
              name="authorize1_signature_key"
              :outsourceSign='authorize1_sign'
              :disabled='disabled'
              @upLoadSignKey='handleSignUpload'
              ></Signature>
              </a-form-model-item>
            </div>
            <div class="claim_text">
              You can generate a signature link for sending and signing. To confirm the signature after submitting, <b>please refresh this page</b>.     生成签名链接用于发送给客户签字，确认签字提交后请
            </div>
            <button
            class="my-2 px-2 py-1 border-black-75 shadow-md border rounded-md block fetch_sign"
            :disabled='disabled'
            @click="refreshAuthorizeSign('authorize_1')"
          >点击此处</button>
            <button
            :disabled='disabled'
            @click='handleShowGenerate("show_authorize1_generate_link")' v-show="show_authorize1_generate_link" class="generate_btn">Generate the Link 生成链接</button>
            <div v-show="!show_authorize1_generate_link" class="general_sign_container">
              <div class="general_sign_title">Copy link to share 复制链接分享</div>
                <div class="general_sign_url">
                  {{getAuthorize1ShareLink}}
                </div>
                <button
                :data-clipboard-text="getAuthorize1ShareLink" ref="copy_btn" class="copy_link_btn">Copy Link 复制链接</button>
                <span v-if="is_copy_success === true" class="copy_success_text">Successfully copied 已复制成功</span>
            </div>
            </div>
          </div>
        </div>
    </div>
    <!-- 授权人2 -->
    <div
      v-if="show_authorize2 === false && has_authorize_other === true"
      @click="show_authorize2 = true"
      class="add_more_auth">Add Authorize..</div>
     <div
      v-if="show_authorize2 === true"
      @click="show_authorize2 = false"
      class="add_more_auth">Delete Authorize..</div>
    <div v-if="show_authorize2" class="step_question_container">
      <h2 class="step_question_title">AUTHORIZED PERSON 授权人 2</h2>
        <div v-if="has_authorize_other">
          <div class="mutiple_form_layout">
            <a-form-model-item
              prop="authorize2_title"
              :style="GetScreenStyle.width30percent"
              required
              label="Title 称谓"
            >
              <a-select
                v-model="threeForm.authorize2_title"
              >
                <a-select-option value="Mr"> Mr </a-select-option>
                <a-select-option value="Miss"> Miss </a-select-option>
                <a-select-option value="Ms"> Ms </a-select-option>
                <a-select-option value="Other"> Other </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              prop="authorize2_First name"
              required
              label="First name 名"
            >
              <a-input
                v-model="threeForm.authorize2_first_name"
                @change="(e)=>{
                handleInput(e, 'authorize2_first_name')
              }"
              />
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              prop="authorize2_last_name"
              required
              label="Last name 姓"
            >
              <a-input
                v-model="threeForm.authorize2_last_name"
                @change="(e)=>{
                handleInput(e, 'authorize2_last_name')
              }"
              />
            </a-form-model-item>
          </div>
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            required
            prop="authorize2_gender"
            label="Gender 性别"
          >
            <a-radio-group
              class="modify_antd_radio_id"
              v-model="threeForm.authorize2_gender"
              name="authorize2_gender"
            >
              <a-radio value="male"> Male </a-radio>
              <a-radio value="female"> Female </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div class="mutiple_form_layout">
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="authorize2_date_of_birth"
              label="Date of Birth 出生日期"
            >
            <a-date-picker
              style="width:100%"
              :inputReadOnly='true'
              @change="(e)=>{
                handleDatePick(e, 'authorize2_date_of_birth')
              }"
              :value="authorize2_dob_formate"
              placeholder="Date of Birth 出生日期"
              />
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="authorize_place_of_birth"
              label="Place of Birth 出生地点"
            >
              <a-input
                v-model="threeForm.authorize2_place_of_birth"
                @change="(e)=>{
                handleInput(e, 'authorize2_place_of_birth')
              }"
              />
            </a-form-model-item>
            <BaseCountrySelection
              :style="GetScreenStyle.width30percent"
              label="Nationality 国籍(及地区)"
              prop="authorize2_nationality"
              :disabled="disabled"
              :selectedVal='threeForm.authorize2_nationality'
              @handleChange='handleSelect'
              valType='code'
            >
            </BaseCountrySelection>
          </div>
          <div class="mutiple_form_layout">
            <BaseCountrySelection
              :style="GetScreenStyle.width45percent"
              label="Country of Tax Residence 税务国家"
              prop="authorize2_tax_country"
              :disabled="disabled"
              :selectedVal='threeForm.authorize2_tax_country'
              @handleChange='handleSelect'
              valType='code'
            >
            </BaseCountrySelection>
            <a-form-model-item
              :style="GetScreenStyle.width45percent"
              label="Relationship 与授权人关系"
              prop="authorize2_relation"
            >
              <a-input
                v-model="threeForm.authorize2_relation"
                @change="(e)=>{
                handleInput(e, 'authorize2_relation')
              }"
              />
            </a-form-model-item>
          </div>
          <div class="mutiple_form_layout">
          <a-form-model-item
          :style="GetScreenStyle.width60percent"
          prop="authorize2_residential_address"
          required
          label="Residential Address(No Po BOX) 居住地址">
            <a-input
              v-model="threeForm.authorize2_residential_address"
              @change="(e)=>{
                handleInput(e, 'authorize2_residential_address')
              }"
            />
          </a-form-model-item>
          <BaseCountrySelection
            :style="GetScreenStyle.width30percent"
            label="Country 国家(及地区)"
            prop="authorize2_country"
            :disabled="disabled"
            :selectedVal='threeForm.authorize2_country'
            @handleChange='handleSelect'
            valType='code'
          >
          </BaseCountrySelection>
          </div>

          <div class="mutiple_form_layout">
            <a-form-model-item
              prop="authorize2_city"
              :style="GetScreenStyle.width30percent"
              required
              label="City 城市"
            >
              <a-input
                v-model="threeForm.authorize2_city"
                @change="(e)=>{
                handleInput(e, 'authorize2_city')
              }"
              />
            </a-form-model-item>
            <a-form-model-item
              prop="authorize2_suburb"
              :style="GetScreenStyle.width30percent"
              required
              label="Suburb 地区"
            >
              <a-input
                v-model="threeForm.authorize2_suburb"
                @change="(e)=>{
                handleInput(e, 'authorize2_suburb')
              }"
              />
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="authorize2_postcode"
              label="Postcode 邮政编码"
            >
              <a-input
                v-model="threeForm.authorize2_postcode"
                @change="(e)=>{
                handleInput(e, 'authorize2_postcode')
              }"
              />
            </a-form-model-item>
          </div>
          <div class="mutiple_form_layout">
            <a-form-model-item
              prop="authorize_home_telephone"
              :style="GetScreenStyle.width30percent"
              required
              label="Home Phone 家庭电话"
            >
              <a-input
                v-model="threeForm.authorize2_home_telephone"
                @change="(e)=>{
                handleInput(e, 'authorize2_home_telephone')
              }"
              />
            </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="authorize2_mobile_phone"
              label="Mobile 移动电话"
            >
              <a-input
                v-model="threeForm.authorize2_mobile_phone"
                @change="(e)=>{
                handleInput(e, 'authorize2_mobile_phone')
              }"
              />
            </a-form-model-item>
            <a-form-model-item
              prop="authorize2_email_address"
              :style="GetScreenStyle.width30percent"
              required
              label="E-mail 电子邮箱"
            >
              <a-input
                v-model="threeForm.authorize2_email_address"
                @change="(e)=>{
                handleInput(e, 'authorize2_email_address')
              }"
              />
            </a-form-model-item>
          </div>
          <div class="mutiple_form_layout">
          <a-form-model-item
            required
            :style="GetScreenStyle.width45percent"
            label="Identification type(证件类型)"
            prop='authorize2_identification_type'
          >
            <a-select
              v-model="threeForm.authorize2_identification_type"
            >
              <a-select-option value="Passport"> Passport(Recommend) </a-select-option>
              <a-select-option value="birth_certificate"> Birth Certificate </a-select-option>
              <a-select-option value="business_certificate"> Business Certificate </a-select-option>
              <a-select-option value="chinese_id_card"> Chinese ID Card </a-select-option>
              <a-select-option value="citizenship_certificate"> Citizenship Certificate </a-select-option>
              <a-select-option value="eightteen_plus_card"> NZ 18+ Card </a-select-option>
              <a-select-option value="nz_firearm_license"> NZ Firearm License </a-select-option>
              <a-select-option value="nz_au_drivers_licence"> NZ/AU Drivers Licence </a-select-option>
              <a-select-option value="other"> Other </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            required
            :style="GetScreenStyle.width45percent"
            label="ID number 证件号码"
            prop="authorize2_id_num"
          >
            <a-input
              v-model="threeForm.authorize2_id_num"
              @change="(e)=>{
                handleInput(e, 'authorize2_id_num')
              }"
            />
          </a-form-model-item>

        </div>
        <!-- 证件上传 -->
        <div class="mutiple_form_layout">
          <a-form-model-item
            required
          :style="GetScreenStyle.width30percent"
            label="Issue Date 签发日期"
            prop="authorize2_issue_date">
            <a-date-picker
              :inputReadOnly='true'
              style="width:100%"
              @change="(e)=>{
                handleDatePick(e, 'authorize2_issue_date')
              }"
              :value="authorize2_issue_date_formate"
              >
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item
          :style="GetScreenStyle.width30percent"
            required
            label="Expiry Date失效日期"
            prop="authorize2_expiry_date">
            <a-date-picker
              :inputReadOnly='true'
              style="width:100%"
              @change="(e)=>{
                handleDatePick(e, 'authorize2_expiry_date')
              }"
              :value="authorize2_expiry_date_formate"
              >
            </a-date-picker>
          </a-form-model-item>
          <BaseCountrySelection
            :style="GetScreenStyle.width30percent"
            label="Issue Country(签发国家)"
            prop="authorize2_issue_country"
            :disabled="disabled"
            :selectedVal='threeForm.authorize2_issue_country'
            @handleChange='handleSelect'
            valType='code'
          >
          </BaseCountrySelection>
        </div>
        <div>
            <!-- asdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasd -->
            <div>
          <div class="step_checkbox_layout">
            <div class="step_sub_title">
              Please upload your ID Vertification 请上传您的ID认证
            </div>
            <ul class="step_ul_style">
              <li>
                Face-to-face channel: with United AU staff assistance to verify
                your documents.
              </li>
              <li>
                Non face-to-face channel: without United AU staff assistance to verify
                your documents.
              </li>
            </ul>
          </div>
          <a-form-model-item
            :style="GetScreenStyle.width100percent"
            required
            label="Choose the channel before uploading your proof of identification:"
            prop="authorize2_prove_channel"
          >
            <a-select
              v-model="threeForm.authorize2_prove_channel"
            >
              <a-select-option value="face_to_face"
                >Face-to-face Channel</a-select-option
              >
              <a-select-option value="none_face_to_face"
                >None Face-to-face Channel
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- face_to_face 上传 -->
          <a-form-model-item
            v-if="threeForm.authorize2_prove_channel == 'face_to_face'"
            :style="GetScreenStyle.width100percent"
            required
            prop="authorize2_face_to_face_type"
            label="Please choose ONE of the following:"
          >
            <a-radio-group
              class="modify_antd_radio"
              name="authorize2_face_to_face_type"
              v-model="threeForm.authorize2_face_to_face_type"
            >
              <a-radio :style="radioStyle" :value="1">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand Passport 澳大利亚/新西兰护照 (the copy
                    of passport photo and signature page 护照信息页和签字页)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese passport 中国护照 (the copy of passport photo,
                    signature page and visa page 护照信息页，签字页和签证页)
                  </li>
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="3">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese passport 中国护照 (the copy of passport photo, signature page and visa page 护照信息页，签字页和签证页);
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="4">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Other passport 其他护照 (the copy of passport photo,
                    signature page and visa page 护照信息页，签字页和签证页)
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <!-- none-face-to-face 证件上传 -->
          <a-form-model-item
            v-if="threeForm.authorize2_prove_channel == 'none_face_to_face'"
            :style="GetScreenStyle.width100percent"
            required
            prop="authorize2_none_face_to_face_type"
            label="Please choose ONE of the following:"
          >
            <a-radio-group
              class="modify_antd_radio"
              name="authorize2_none_face_to_face_type"
              v-model="threeForm.authorize2_none_face_to_face_type"
            >
              <a-radio :style="radioStyle" :value="1">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand Passport 澳大利亚/新西兰护照 (the copy
                    of passport photo and signature page 护照信息页和签字页)
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 驾照正反面)
                  </li>
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                  <li>
                    Chinese Passport (the copy of passport photo, signature page
                    and visa page 护照信息页，签字页和签证页《如有》)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="3">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                  <li class="li_require">
                    Chinese bank card (the copy of front and back side
                    银行卡正面)
                  </li>
                  <li>
                    Chinese Passport (the copy of passport photo, signature page
                    and visa page 护照信息页，签字页和签证页《如有》)
                  </li>
                </ul>
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div v-if="authorize2_prove_channel">
            <AFileMessage
              v-for="item in author2IdProve[threeForm.authorize2_prove_channel][author2ProveIndex]"
              :key="item.id"
              :obj='item'
              @handleInput='handleInput'
              @handleFileChange="handleFileList"
              @FileValidate='FileValidate'
              @handleSelect='handleSelect'
            />
          </div>
        </div>
            <!-- asdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasd -->
            <div>
              <div class="step_sub_title">
              Please upload your Proof of Address(select one)
              请上传您的地址认证（请选择一个上传）
            </div>
              <div class="ul_main_title">
                1.Bank Statements and Bank Correspondence 银行对账单和银行通信
              </div>
              <ul class="step_ul_style">
                <li>
                  This must be a statement from a bank/IRD that has been posted
                  to the client and is dated within the last 3 months.
                  这必须是银行/
                  IRD的记录，该记录信件必须是最近三个月内通过信件发送给注册人的。
                </li>
                <li>
                  Bank correspondence must confirm a business relationship
                  exists between the bank and the client.
                  银行通信必须是能确认银行与注册人之间存在业务关系的
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                </li>
              </ul>
            </div>
            <!-- 2. -->
            <div>
              <div class="ul_main_title">2.Utility Bill 各种账单</div>
              <ul class="step_ul_style">
                <li>
                  This must be a statement for utility service at a fixed
                  location that has been posted to the client and is dated
                  within the last 3 months.
                  这必须最近三个月内通过邮寄发送去注册人的账单。
                </li>
                <li>
                  Fixed services include electricity, water, gas, home
                  internet/landlines and Sky.
                  服务账单包括电力，水，煤气，家庭互联网/固定电话和电视。
                </li>
                <li>
                  Fixed services do not include mobile phones.
                  服务账单不包括手机账单
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. . 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                </li>
              </ul>
            </div>
            <!-- 3. -->
            <div>
              <div class="ul_main_title">
                3.Government Agency Correspondence (Council Rates, etc.)
                政府机构通信
              </div>
              <ul class="step_ul_style">
                <li>
                  This must be a statement, letter or invoice that has been
                  posted to the client from a government agency and is dated
                  within the last 3 months.
                  这必须最近三个月内来自政府机构通过邮寄发送去注册人的声明/信件/发票。
                </li>
                <li>
                  This includes confirmation of bond lodgements with the
                  Department of Building and Housing.
                  这可以是来自于建筑和住房部押金投管确认信
                </li>
                <li>
                  Fixed services do not include mobile phones.
                  服务账单不包括手机账单
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. . 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                </li>
              </ul>
            </div>
            <!-- 4. -->
            <div>
              <div class="ul_main_title">
                4.Electoral Commission Correspondence 选举委员会函件
              </div>
              <ul class="step_ul_style">
                <li>
                  This must be a letter that has been posted to the client and
                  is dated within the last 3 months.
                  这必须是三个月内通过邮寄发送至注册人的信件
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. . 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息
                </li>
              </ul>
            </div>
            <!-- 5. -->
            <div>
              <div class="ul_main_title">
                5.Tenancy Agreement 租赁协议 Correspondence 选举委员会函件
              </div>
              <ul class="step_ul_style">
                <li>
                  This must be a signed tenancy agreement dated within the last
                  3 months. 这必须是过去3个月内签署的租赁协议
                </li>
              </ul>
            </div>
            <!-- 6. -->
            <div>
              <div class="ul_main_title">6.Vehicle Registration 车辆登记</div>
              <ul class="step_ul_style">
                <li>
                  This must be a current vehicle registration that has been
                  posted to the client and is dated within the last 3 months.
                  这必须是三个月内通过邮寄发送给注册人的车辆登记信件
                </li>
                <li>
                  Printed information from online account or email
                  correspondence is not acceptable unless it is JP/lawyer
                  certified. . 除非获得JP
                  /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                </li>
              </ul>
            </div>
            <!-- 地址认证上传 -->
            <div class="step_upload_box marginT_10">
              <!-- <AUploadFile
                title=""
                prop="authorize2_address_prove_file_list"
                :fileList="authorize2_address_prove_file_list"
                @handleFileChange="handleFileList"
                /> -->
              <div class="step_notice_text marginT_10">
                The file's fomat supports JPG,PNG,JPEG,PDF or any video types
                and the size is not exceed 20MB
              </div>
            </div>
            <div>
              <div class="step_sub_title">
              Authorized Person Signature 授权人签名
              <a-form-model-item
              prop="authorize2_signature_key"
              >
              <Signature
              name="authorize2_signature_key"
              class="marginX20"
              :outsourceSign='authorize2_sign'
              @upLoadSignKey='handleSignUpload'
              ></Signature>
              </a-form-model-item>
            </div>
            <div class="claim_text">
              You can generate a signature link for sending and signing. To confirm the signature after submitting, <b>please refresh this page</b>.     生成签名链接用于发送给客户签字，确认签字提交后请
            </div>
            <button
              class=" my-2 px-2 py-1 border-black-75 shadow-md border rounded-md block "
              @click="refreshAuthorizeSign('authorize_2')"
            >点击此处</button>
            <button
            :disabled='disabled'
            @click='handleShowGenerate("show_authorize2_generate_link")' v-show="show_authorize2_generate_link" class="generate_btn">Generate the Link 生成链接</button>
            <div v-show="!show_authorize2_generate_link" class="general_sign_container">
              <div class="general_sign_title">Copy link to share 复制链接分享</div>
                <div class="general_sign_url">
                  {{getAuthorize2ShareLink}}
                </div>
                <button
                :data-clipboard-text="getAuthorize2ShareLink" ref="copy_btn" class="copy_link_btn">Copy Link 复制链接</button>
                <span v-if="is_copy_success === true" class="copy_success_text">Successfully copied 已复制成功</span>
            </div>
            </div>
          </div>
        </div>
    </div>
  </a-form-model>
</div>
</template>

<script>
import rules from '@/assets/rules/threeRules.js'
import { mapActions, mapGetters, mapState } from 'vuex'
import Signature from '../../../../components/Signature.vue'
import AUploadFile from '../../../../components/AUploadFile'
import AFileMessage from '../../../../components/AFileMessage'
import { getAwsPic, fetchSign } from '@/api/common'
import moment from 'moment'
import BaseCountrySelection from '@/components/BaseCountrySelection'
import BaseAddress from '@/components/BaseAddress.vue'

export default {

  data () {
    return {
      authorize1_sign: null,
      authorize2_sign: null,
      radioStyle: {
        lineHeight: '30px',
        width: '100%',
        marginBottom: '10px'
      },
      show_authorize2: false,
      show_authorize1_generate_link: true,
      show_authorize2_generate_link: true,
      is_copy_success: false,
      copyValue: 'hello world',
      activeKey: 0,
      panes: [
        { title: 'Tax Number 税务信息 # 1', content: { other_tax_contry: 'male', other_tax_num: 'other_tax_num' }, key: 0, closable: false }
      ],
      newTabIndex: 0,
      // ori
      residential_country_list: [],
      labelCol: { span: 24 },
      wrapperCol: { span: 24 }
    }
  },
  watch: {
    authorize1_signature_key (newValue) {
      this.fetchSign(newValue, 'authorize1_sign')
    },
    authorize2_signature_key (newValue) {
      this.fetchSign(newValue, 'authorize2_sign')
    }
  },
  created () {
    this.rules = rules
    if (this.authorize1_signature_key) {
      this.fetchSign(this.authorize1_signature_key, 'authorize1_sign')
    }
    if (this.authorize2_signature_key) {
      this.fetchSign(this.authorize2_signature_key, 'authorize2_sign')
    }
  },
  components: {
    Signature,
    AUploadFile,
    AFileMessage,
    BaseCountrySelection,
    BaseAddress
  },
  methods: {
    FileValidate (val) {
      if (val) {
        this.$refs.person_third_form.validateField([val])
      } else {
        this.$refs.person_third_form.validate()
      }
    },
    handleDatePick (value, content) {
      if (value) {
        this.ChangeFormAction({ content, value: value.format() })
      }
    },
    refreshAuthorizeSign (e) {
      if (e) {
        const query = {
          type: e
        }
        fetchSign(query).then(res => {
          if (e === 'authorize_1') {
            this.ChangeFormAction({
              content: 'authorize1_signature_key',
              value: res.signature
            })
            this.fetchSign(res.signature, 'authorize1_sign')
          } else if (e === 'authorize_2') {
            this.ChangeFormAction({
              content: 'authorize2_signature_key',
              value: res.signature
            })
            this.fetchSign(res.signature, 'authorize2_sign')
          }
        })
      }
    },
    fetchSign (from, x) {
      const query = {
        key: from
      }
      getAwsPic(query).then(res => {
        if (res.url) {
          this[x] = res.url
        }
      })
    },
    handleSignUpload (content, val) {
      this.ChangeFormAction({ content, value: val })
        .then(() => {
          this.$refs.person_third_form.validate()
        })
    },
    handleFileList (fileList, content) {
      this.ChangeObjectAction({ content, value: fileList })
    },
    handleRadio (e) {
      const { name, value } = e.target
      this.ChangeFormAction({ content: name, value })
    },

    onEdit (targetKey, action) {
      this[action](targetKey)
    },
    handleInput (e, content) {
      const { value } = e.target
      const _value = value.replace(/[\u4E00-\u9FA5]/g, '')
      this.ChangeFormAction({ content, value: _value })
    },
    handleSelect (content, value) {
      this.ChangeFormAction({ content, value })
    },
    handleShowGenerate (val) {
      this[val] = false
    },
    ...mapActions('personStepThree', ['ChangeFormAction', 'ChangeObjectAction'])
  },
  beforeRouteLeave (to, from, next) {
    if (this.disabled) {
      next()
    } else {
      this.$refs.person_third_form.validate(valid => {
        if (valid) {
          next()
        } else {
          next()
        }
      })
    }
  },
  computed: {
    authorize1_dob_formate () {
      if (this.authorize1_date_of_birth) {
        return moment(this.authorize1_date_of_birth)
      }
      return null
    },
    authorize1_issue_date_formate () {
      if (this.authorize1_issue_date) {
        return moment(this.authorize1_issue_date)
      }
      return null
    },
    authorize1_expiry_date_formate () {
      if (this.authorize1_expiry_date) {
        return moment(this.authorize1_expiry_date)
      }
      return null
    },
    authorize2_issue_date_formate () {
      if (this.authorize2_issue_date) {
        return moment(this.authorize2_issue_date)
      }
      return null
    },
    authorize2_expiry_date_formate () {
      if (this.authorize2_expiry_date) {
        return moment(this.authorize2_expiry_date)
      }
      return null
    },
    authorize2_dob_formate () {
      if (this.authorize2_date_of_birth) {
        return moment(this.authorize2_date_of_birth)
      }
      return null
    },
    author1nzPassportFile () {
      return {
        id: 15,
        desc: 'Australia/New Zealand Passport 澳大利亚/新西兰护照 (the copy of passport photo and signature page 护照信息页和签字页) ',
        message: [{
          mid: 52,
          proof_num: this.authorize1_nz_au_passport_num,
          proof_num_str: 'authorize1_nz_au_passport_num',
          belongs_to: this.authorize1_nz_au_passport_country,
          belongs_to_str: 'authorize1_nz_au_passport_country',
          belongs_to_str_disabled: false,
          country_selection: [
            {
              name: 'Australia',
              dial_code: '+61',
              code: 'AU'
            },
            {
              name: 'New Zealand',
              dial_code: '+64',
              code: 'NZ'
            }
          ]
        }],
        upload: [
          {
            fid: 53,
            title: 'Australia/New Zealand护照信息页+签字页',
            prop: 'authorize1_nz_au_passport_file_list',
            file: this.authorize1_nz_au_passport_file_list
          }
        ]
      }
    },
    author1nzDriverFile () {
      return {
        id: 2,
        desc: 'Australia/New Zealand driver licence (the copy of front and back side 澳大利亚/新西兰驾照正反面)',
        message: [{
          mid: 1,
          proof_num: this.authorize1_nz_au_driver_num,
          proof_num_str: 'authorize1_nz_au_driver_num',
          belongs_to: this.authorize1_nz_au_driver_country,
          belongs_to_str: 'authorize1_nz_au_driver_country',
          belongs_to_str_disabled: false,
          country_selection: [
            {
              name: 'Australia',
              dial_code: '+61',
              code: 'AU'
            },
            {
              name: 'New Zealand',
              dial_code: '+64',
              code: 'NZ'
            }
          ]
        }],
        upload: [
          {
            fid: 2,
            title: '澳大利亚/新西兰驾照正面',
            prop: 'authorize1_nz_au_driver_front_file_list',
            file: this.authorize1_nz_au_driver_front_file_list
          },
          {
            fid: 3,
            title: '澳大利亚/新西兰驾照反面',
            prop: 'authorize1_nz_au_driver_back_file_list',
            file: this.authorize1_nz_au_driver_back_file_list
          }
        ]
      }
    },
    author1cnPassport () {
      return {
        id: 3,
        desc: 'Chinese passport 中国护照 (the copy of passport photo护照信息页) ',
        message: [
          {
            mid: 1,
            proof_num: this.authorize1_cn_passport_num,
            proof_num_str: 'authorize1_cn_passport_num',
            belongs_to: this.authorize1_cn_passport_country,
            belongs_to_str: 'authorize1_cn_passport_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 4,
            title: '中国护照信息页+签字页',
            prop: 'authorize1_cn_passport_file_list',
            file: this.authorize1_cn_passport_file_list
          },
          {
            fid: 5,
            title: '中国护照签证页',
            prop: 'authorize1_cn_passport_visa_file_list',
            file: this.authorize1_cn_passport_visa_file_list
          }
        ]
      }
    },

    author1cnIdentify () {
      return {
        id: 5,
        desc: 'Chinese National ID (the copy of front and back side 身份证正反面) ',
        message: [
          {
            mid: 3,
            proof_num: this.authorize1_cn_identify_front_num,
            proof_num_str: 'authorize1_cn_identify_front_num',
            belongs_to: this.authorize1_cn_identify_front_country,
            belongs_to_str: 'authorize1_cn_identify_front_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 6,
            title: '中国身份证正面',
            prop: 'authorize1_cn_identify_front_file_list',
            file: this.authorize1_cn_identify_front_file_list
          },
          {
            fid: 7,
            title: '中国身份证反面',
            prop: 'authorize1_cn_identify_back_file_list',
            file: this.authorize1_cn_identify_back_file_list
          }
        ]
      }
    },
    author1cnBankCard () {
      return {
        id: 6,
        desc: 'Chinese bank card (the copy of front and back side 银行卡正面)',
        message: [
          {
            mid: 4,
            proof_num: this.authorize1_cn_bank_front_num,
            proof_num_str: 'authorize1_cn_bank_front_num',
            belongs_to: this.authorize1_cn_bank_front_country,
            belongs_to_str: 'authorize1_cn_bank_front_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 8,
            prop: 'authorize1_cn_bank_front_file_list',
            title: '中国银行卡正面',
            file: this.authorize1_cn_bank_front_file_list
          }
        ]
      }
    },
    author1cnPassportOption () {
      return {
        id: 7,
        desc: 'Chinese passport 中国护照 (the copy of passport photo护照信息页)(如有)',
        message: [
          {
            mid: 5,
            proof_num: this.authorize1_cn_passport_not_required_num,
            proof_num_str: 'authorize1_cn_passport_not_required_num',
            belongs_to: this.authorize1_cn_passport_not_required_country,
            belongs_to_str: 'authorize1_cn_passport_not_required_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 10,
            title: '中国护照信息页+签字页(如有)',
            prop: 'authorize1_cn_passport_not_required_file_list',
            file: this.authorize1_cn_passport_not_required_file_list
          },
          {
            fid: 11,
            title: '中国护照签证页(如有)',
            prop: 'authorize1_cn_passport_not_required_visa_file_list',
            file: this.authorize1_cn_passport_not_required_visa_file_list
          }
        ]
      }
    },

    author1otherPassport () {
      return {
        id: 9,
        desc: 'Other passport 其他护照 (the copy of passport photo 护照信息页)',
        message: [
          {
            mid: 7,
            proof_num: this.authorize1_other_identify_num,
            proof_num_str: 'authorize1_other_identify_num',
            belongs_to: this.authorize1_other_identify_country,
            belongs_to_str: 'authorize1_other_identify_country',
            belongs_to_str_disabled: false,
            country_selection: this.allCountryList
          }
        ],
        upload: [
          {
            fid: 12,
            title: '其他护照信息页+签字页',
            prop: 'authorize1_other_identify_file_list',
            file: this.authorize1_other_identify_file_list
          },
          {
            fid: 13,
            title: '其他护照签证页',
            prop: 'authorize1_other_passport_visa_file_list',
            file: this.authorize1_other_passport_visa_file_list
          }
        ]
      }
    },

    author2nzPassportFile () {
      return {
        id: 15,
        desc: 'Australia/New Zealand Passport 澳大利亚/新西兰护照 (the copy of passport photo and signature page 护照信息页和签字页) ',
        message: [{
          mid: 52,
          proof_num: this.authorize2_nz_au_passport_num,
          proof_num_str: 'authorize2_nz_au_passport_num',
          belongs_to: this.authorize2_nz_au_passport_country,
          belongs_to_str: 'authorize2_nz_au_passport_country',
          belongs_to_str_disabled: false,
          country_selection: [
            {
              name: 'Australia',
              dial_code: '+61',
              code: 'AU'
            },
            {
              name: 'New Zealand',
              dial_code: '+64',
              code: 'NZ'
            }
          ]
        }],
        upload: [
          {
            fid: 53,
            title: 'Australia/New Zealand护照信息页+签字页',
            prop: 'authorize2_nz_au_passport_file_list',
            file: this.authorize2_nz_au_passport_file_list
          }
        ]
      }
    },
    author2nzDriverFile () {
      return {
        id: 2,
        desc: 'Australia/New Zealand driver licence (the copy of front and back side 澳大利亚/新西兰驾照正反面)',
        message: [{
          mid: 1,
          proof_num: this.authorize2_nz_au_driver_num,
          proof_num_str: 'authorize2_nz_au_driver_num',
          belongs_to: this.authorize2_nz_au_driver_country,
          belongs_to_str: 'authorize2_nz_au_driver_country',
          belongs_to_str_disabled: false,
          country_selection: [
            {
              name: 'Australia',
              dial_code: '+61',
              code: 'AU'
            },
            {
              name: 'New Zealand',
              dial_code: '+64',
              code: 'NZ'
            }
          ]
        }],
        upload: [
          {
            fid: 2,
            title: '澳大利亚/新西兰驾照正面',
            prop: 'authorize2_nz_au_driver_front_file_list',
            file: this.authorize2_nz_au_driver_front_file_list
          },
          {
            fid: 3,
            title: '澳大利亚/新西兰驾照反面',
            prop: 'authorize2_nz_au_driver_back_file_list',
            file: this.authorize2_nz_au_driver_back_file_list
          }
        ]
      }
    },
    author2cnPassport () {
      return {
        id: 3,
        desc: 'Chinese passport 中国护照 (the copy of passport photo护照信息页) ',
        message: [
          {
            mid: 1,
            proof_num: this.authorize2_cn_passport_num,
            proof_num_str: 'authorize2_cn_passport_num',
            belongs_to: this.authorize2_cn_passport_country,
            belongs_to_str: 'authorize2_cn_passport_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 4,
            title: '中国护照信息页+签字页',
            prop: 'authorize2_cn_passport_file_list',
            file: this.authorize2_cn_passport_file_list
          },
          {
            fid: 5,
            title: '中国护照签证页',
            prop: 'authorize2_cn_passport_visa_file_list',
            file: this.authorize2_cn_passport_visa_file_list
          }
        ]
      }
    },

    author2cnIdentify () {
      return {
        id: 5,
        desc: 'Chinese National ID (the copy of front and back side 身份证正反面) ',
        message: [
          {
            mid: 3,
            proof_num: this.authorize2_cn_identify_front_num,
            proof_num_str: 'authorize2_cn_identify_front_num',
            belongs_to: this.authorize2_cn_identify_front_country,
            belongs_to_str: 'authorize2_cn_identify_front_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 6,
            title: '中国身份证正面',
            prop: 'authorize2_cn_identify_front_file_list',
            file: this.authorize2_cn_identify_front_file_list
          },
          {
            fid: 7,
            title: '中国身份证反面',
            prop: 'authorize2_cn_identify_back_file_list',
            file: this.authorize2_cn_identify_back_file_list
          }
        ]
      }
    },
    author2cnBankCard () {
      return {
        id: 6,
        desc: 'Chinese bank card (the copy of front and back side 银行卡正面)',
        message: [
          {
            mid: 4,
            proof_num: this.authorize2_cn_bank_front_num,
            proof_num_str: 'authorize2_cn_bank_front_num',
            belongs_to: this.authorize2_cn_bank_front_country,
            belongs_to_str: 'authorize2_cn_bank_front_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 8,
            prop: 'authorize2_cn_bank_front_file_list',
            title: '中国银行卡正面',
            file: this.authorize2_cn_bank_front_file_list
          }
        ]
      }
    },
    author2cnPassportOption () {
      return {
        id: 7,
        desc: 'Chinese passport 中国护照 (the copy of passport photo护照信息页)(如有)',
        message: [
          {
            mid: 5,
            proof_num: this.authorize2_cn_passport_not_required_num,
            proof_num_str: 'authorize2_cn_passport_not_required_num',
            belongs_to: this.authorize2_cn_passport_not_required_country,
            belongs_to_str: 'authorize2_cn_passport_not_required_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 10,
            title: '中国护照信息页+签字页(如有)',
            prop: 'authorize2_cn_passport_not_required_file_list',
            file: this.authorize2_cn_passport_not_required_file_list
          },
          {
            fid: 11,
            title: '中国护照签证页(如有)',
            prop: 'authorize2_cn_passport_not_required_visa_file_list',
            file: this.authorize2_cn_passport_not_required_visa_file_list
          }
        ]
      }
    },

    author2otherPassport () {
      return {
        id: 9,
        desc: 'Other passport 其他护照 (the copy of passport photo 护照信息页)',
        message: [
          {
            mid: 7,
            proof_num: this.authorize2_other_identify_num,
            proof_num_str: 'authorize2_other_identify_num',
            belongs_to: this.authorize2_other_identify_country,
            belongs_to_str: 'authorize2_other_identify_country',
            belongs_to_str_disabled: false,
            country_selection: this.allCountryList
          }
        ],
        upload: [
          {
            fid: 12,
            title: '其他护照信息页+签字页',
            prop: 'authorize2_other_identify_file_list',
            file: this.authorize2_other_identify_file_list
          },
          {
            fid: 13,
            title: '其他护照签证页',
            prop: 'authorize2_other_passport_visa_file_list',
            file: this.authorize2_other_passport_visa_file_list
          }
        ]
      }
    },

    author1ProveIndex () {
      if (this.authorize1_prove_channel === 'face_to_face') {
        return this.authorize1_face_to_face_type - 1
      } else if (
        this.authorize1_prove_channel === 'none_face_to_face'
      ) {
        return this.authorize1_none_face_to_face_type - 1
      } else {
        return 0
      }
    },
    author2ProveIndex () {
      if (this.authorize2_prove_channel === 'face_to_face') {
        return this.authorize2_face_to_face_type - 1
      } else if (
        this.authorize2_prove_channel === 'none_face_to_face'
      ) {
        return this.authorize2_none_face_to_face_type - 1
      } else {
        return 0
      }
    },
    author1IdProve () {
      return {
        face_to_face: [
          [
            this.author1nzPassportFile
          ],
          [
            this.author1cnPassport,
            this.author1cnIdentify
          ],
          [
            this.author1cnPassport,
            this.author1nzDriverFile
          ],
          [
            this.author1otherPassport,
            this.author1nzDriverFile
          ]
        ],
        none_face_to_face: [
          [
            this.author1nzPassportFile,
            this.author1nzDriverFile
          ],
          [
            this.author1nzDriverFile,
            this.author1cnIdentify,
            this.author1cnPassportOption
          ],
          [
            this.author1cnIdentify,
            this.author1cnBankCard,
            this.author1cnPassportOption
          ]
        ]
      }
    },
    author2IdProve () {
      return {
        face_to_face: [
          [
            this.author2nzPassportFile
          ],
          [
            this.author2cnPassport,
            this.author2cnIdentify
          ],
          [
            this.author2cnPassport,
            this.author2nzDriverFile
          ],
          [
            this.author2otherPassport,
            this.author2nzDriverFile
          ]
        ],
        none_face_to_face: [
          [
            this.author2nzPassportFile,
            this.author2nzDriverFile
          ],
          [
            this.author2nzDriverFile,
            this.author2cnIdentify,
            this.author2cnPassportOption
          ],
          [
            this.author2cnIdentify,
            this.author2cnBankCard,
            this.author2cnPassportOption
          ]
        ]
      }
    },
    threeForm () {
      return this.$store.state.personStepThree
    },
    getAuthorize1ShareLink () {
      if (this.attributes && this.attributes.username) {
        return `${window.location.host}/signpage/?username=${this?.attributes?.username}&type=authorize_1&customer_type=I&token=${encodeURI(JSON.stringify(this.AwsToken))}`
      }
      return null
    },
    getAuthorize2ShareLink () {
      if (this.attributes && this.attributes.username) {
        return `${window.location.host}/signpage/?username=${this?.attributes?.username}type=authorize_2&customer_type=I&token=${encodeURI(JSON.stringify(this.AwsToken))}`
      }
      return null
    },
    authorize1_get_show_generate_link () {
      return this.show_generate_link === false
    },
    authorize2_get_show_generate_link () {
      return this.show_generate_link === false
    },
    getLastPanesKey () {
      return this.panes[this.panes.length - 1].key
    },
    ...mapState('login', ['AwsToken', 'user', 'attributes']),
    ...mapState('personStepThree',
      ['has_authorize_other', 'authorize1_title', 'authorize1_first_name', 'authorize1_last_name', 'authorize1_gender', 'authorize1_date_of_birth', 'authorize1_place_of_birth', 'authorize1_nationality', 'authorize1_tax_country', 'authorize1_suburb', 'authorize1_relation', 'authorize1_residential_address', 'authorize1_city', 'authorize1_country', 'authorize1_postcode', 'authorize1_mobile_phone', 'authorize1_dial_code', 'authorize1_email_address', 'authorize1_address_prove_file_list', 'authorize1_signature', 'authorize1_prove_channel', 'authorize1_face_to_face_type', 'authorize1_none_face_to_face_type', 'authorize1_nz_au_passport_file_list', 'authorize1_expiry_date', 'authorize1_cn_passport_file_list', 'authorize1_issue_date', 'authorize1_identification', 'authorize1_identification_type', 'authorize1_id_num', 'authorize1_issue_country', 'authorize1_cn_passport_visa_file_list', 'authorize1_cn_identify_front_file_list', 'authorize1_cn_identify_back_file_list', 'authorize1_other_identify_file_list', 'authorize1_other_passport_visa_file_list', 'authorize1_nz_au_driver_front_file_list', 'authorize1_nz_au_driver_back_file_list', 'authorize1_cn_passport_not_required_file_list', 'authorize1_cn_passport_not_required_visa_file_list', 'authorize1_cn_bank_front_file_list', 'authorize1_cn_bank_back_file_list', 'authorize1_nz_au_passport_num', 'authorize1_nz_au_passport_country', 'authorize1_cn_passport_num', 'authorize1_cn_passport_country', 'authorize1_cn_passport_visa_num', 'authorize1_cn_passport_visa_country', 'authorize1_cn_identify_front_num', 'authorize1_cn_identify_front_country', 'authorize1_other_identify_num', 'authorize1_other_identify_country', 'authorize1_other_passport_visa_num', 'authorize1_other_passport_visa_country', 'authorize1_nz_au_driver_num', 'authorize1_nz_au_driver_country', 'authorize1_cn_passport_not_required_num', 'authorize1_cn_passport_not_required_country', 'authorize1_cn_passport_not_required_visa_num', 'authorize1_cn_passport_not_required_visa_country', 'authorize1_cn_bank_front_country', 'authorize1_cn_bank_front_num',
        // 分割一下
        'authorize2_title', 'authorize2_first_name', 'authorize2_last_name', 'authorize2_gender', 'authorize2_date_of_birth', 'authorize2_place_of_birth', 'authorize2_nationality', 'authorize2_tax_country', 'authorize2_relation', 'authorize2_suburb', 'authorize2_residential_address', 'authorize2_city', 'authorize2_country', 'authorize2_postcode', 'authorize2_id_num', 'authorize2_identification_type', 'authorize2_mobile_phone', 'authorize2_dial_code', 'authorize2_email_address', 'authorize2_issue_country', 'authorize2_expiry_date', 'authorize2_issue_date', 'authorize2_address_prove_file_list', 'authorize2_signature', 'authorize2_prove_channel', 'authorize2_face_to_face_type', 'authorize2_none_face_to_face_type', 'authorize2_nz_au_passport_file_list', 'authorize2_cn_passport_file_list', 'authorize2_cn_passport_visa_file_list', 'authorize2_cn_identify_front_file_list', 'authorize2_cn_identify_back_file_list', 'authorize2_other_identify_file_list', 'authorize2_other_passport_visa_file_list', 'authorize2_nz_au_driver_front_file_list', 'authorize2_nz_au_driver_back_file_list', 'authorize2_cn_passport_not_required_file_list', 'authorize2_cn_passport_not_required_visa_file_list', 'authorize2_cn_bank_front_file_list', 'authorize2_cn_bank_back_file_list', 'authorize2_nz_au_passport_num', 'authorize2_nz_au_passport_country', 'authorize2_cn_passport_num', 'authorize2_cn_passport_country', 'authorize2_cn_passport_visa_num', 'authorize2_cn_passport_visa_country', 'authorize2_cn_identify_front_num', 'authorize2_cn_identify_front_country', 'authorize2_other_identify_num', 'authorize2_other_identify_country', 'authorize2_other_passport_visa_num', 'authorize2_other_passport_visa_country', 'authorize2_nz_au_driver_num', 'authorize2_nz_au_driver_country', 'authorize2_cn_passport_not_required_num', 'authorize2_cn_passport_not_required_country', 'authorize2_cn_passport_not_required_visa_num', 'authorize2_cn_passport_not_required_visa_country', 'authorize2_cn_bank_front_country', 'authorize2_cn_bank_front_num',
        'authorize1_address_prove_file_list',
        'authorize2_signature_key',
        'authorize1_signature_key'
      ]),
    ...mapState('countrySelection', ['popularCountryList', 'allCountryList']),
    ...mapGetters('layout', ['GetScreenStyle']),
    ...mapGetters({
      disabled: 'login/getComplainceActive'
    })
  }
}
</script>

<style scoped>

.step_container {
  background: rgb(248, 248, 248);
  padding: 0 1rem;
}

.mutiple_form_layout {
  display: flex;
  justify-content: space-between;
}
.step_sub_title {
  margin: 20px 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}
.ul_main_title {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
  margin-top: 15px;
  margin-bottom: 10px;
}
.step_ul_style {
  list-style-type: inside;
  list-style-type: disc;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 300;
}
.step_ul_style li {
  line-height: 30px;
}
.step_notice_text {
  font-size: 13px;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.65);
}
.marginT_10 {
  margin-top: 15px;
}
.marginX20{
  margin: 20px 0;
}
.claim_text{
  font-weight: 300;
  font-size:17px;
  line-height: 28px;
}
.general_sign_container{
  margin-top: 10px;
  background: #f8f8f8;
  padding:10px;
}
.generate_btn{
  border: 1px solid #ea7840;
  color: #ea7840;
  padding: 10px;
  font-size: 15px;
  font-weight: 300;
  background-color: #fff;
  outline: none;
  margin-top: 5px;
  transition: .2s;
}
.generate_btn:hover{
  background-color:#ea7840;
  color: #fff;
}
.generate_btn:disabled{
  cursor: not-allowed;
}
.general_sign_title{
  font-size: 15px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}
.general_sign_url{
  font-weight: 300;
  margin-top:5px;
  word-break: break-all;
}
.copy_link_btn{
  background-color: #ea7840;
  color: #fff;
  padding: 3px;
  font-size: 14px;
  transition: .2s;
  outline: none;
  display: block;
  margin: 5px 0;
}
.copy_link_btn:hover{
  background: #f09f74;
}
.copy_success_text{
  font-weight: 300;
  color: red;
  font-size: 13px;
}
.modify_antd_radio >>> .ant-radio-inner{
  width: 26px;
  height: 26px;
}
.modify_antd_radio >>> .ant-radio-checked::after{
  height: 25px;
}
.modify_antd_radio >>> .ant-radio-wrapper{
  white-space: pre-wrap;
  display: flex;
}
.modify_antd_radio >>> .ant-radio-inner::after{
  width: 12px;
  left: 6px;
  top: 6px;
  height: 12px;
}
.ant-form >>> label{
  font-size: 15px;
}
@media only screen and (max-width: 768px) {
  .mutiple_form_layout{
    display: flex;
    flex-direction: column;
  justify-content: space-between;
  }
}
</style>
